module.exports = __webpack_public_path__ + "static/media/pain-management.da4c388a.png";